export const updateSearchQuery = query => ({
  type: 'UPDATE_SEARCH_QUERY',
  query
});

export const updateSearchResults = results => ({
  type: 'UPDATE_SEARCH_RESULTS',
  results
});

export const clearSearch = () => ({
  type: 'CLEAR_SEARCH'
});

export const setSearchActive = value => ({
  type: 'SET_SEARCH_ACTIVE',
  value
});
